module.exports = __webpack_public_path__ + "img/LCN-Logo-small.6eb9b01e.png";